import styled from "styled-components";

import { ClipQualityIcon } from "MVVM/Components/Icons";

interface IClipSettingsButton {
  onClick: () => void;
  label?: string;
}

export const ClipSettingsButton = ({
  onClick,
  label = "Clip Settings",
}: IClipSettingsButton) => (
  <StyledClipSettingsButton onClick={onClick}>
    <ClipQualityIcon size={16} />
    {label}
  </StyledClipSettingsButton>
);

const StyledClipSettingsButton = styled.button`
  align-items: center;
  background: ${({ theme }) => theme.colors.navy50};
  border: none;
  border-radius: 8px;
  color: white;
  cursor: pointer;
  display: flex;
  font-family: Barlow, sans-serif;
  font-size: 14px;
  font-weight: 600;
  gap: 8px;
  height: 36px;
  justify-content: center;
  padding: 0 16px;
  transition: all 0.15s ease;
  white-space: nowrap;

  &:hover {
    background: ${({ theme }) => theme.colors.navy};
  }
`;
